/**
 * TableHeaderCell - Reusable sortable table header cell
 */
import React from 'react';
import { Info } from 'lucide-react';
import Tooltip from '../../ui/overlays/Tooltip';

export function TableHeaderCell({ 
  label, 
  sortKey, 
  tooltipContent, 
  tooltipId,
  handleSort, 
  getSortIcon,
  align = 'left'
}) {
  const alignmentClass = align === 'center' ? 'text-center justify-center' : 'text-left';
  
  return (
    <th 
      className={`px-6 py-3 ${alignmentClass} text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700/50 select-none`}
      onClick={() => handleSort(sortKey)}
    >
      <div className={`flex items-center space-x-1 ${align === 'center' ? 'justify-center' : ''}`}>
        <span>{label}</span>
        {tooltipContent && (
          <Tooltip content={tooltipContent} id={tooltipId}>
            <Info className="w-3 h-3 text-gray-400 hover:text-gray-600 dark:hover:text-gray-300" />
          </Tooltip>
        )}
        {getSortIcon(sortKey)}
      </div>
    </th>
  );
}

export function StaticHeaderCell({ label, tooltipContent, tooltipId, align = 'left' }) {
  const alignmentClass = align === 'center' ? 'text-center justify-center' : 'text-left';
  
  return (
    <th className={`px-6 py-3 ${alignmentClass} text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider`}>
      <div className={`flex items-center space-x-1 ${align === 'center' ? 'justify-center' : ''}`}>
        <span>{label}</span>
        {tooltipContent && (
          <Tooltip content={tooltipContent} id={tooltipId}>
            <Info className="w-3 h-3 text-gray-400 hover:text-gray-600 dark:hover:text-gray-300" />
          </Tooltip>
        )}
      </div>
    </th>
  );
}

